import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage as FM } from 'react-intl';
import { connect } from 'react-redux';

const defaultProps = {
  name: 'N/A'
};
const propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string
};

const ReportInfo = ({ name }) => (
  <FM id="page.SlotTable.reportSource" values={{ name }}>
    {txt => <div className="pl-lg pr-lg pb-md pt-md">{txt}</div>}
  </FM>
);

const mapStateToProps = ({ global, metaData, dashboardSettings }, ownProps) => {
  // find slot data
  const { id } = ownProps;
  const slotData = dashboardSettings.details.slots.find(s => s.id === id) || {};

  // find report data
  const { reportId } = slotData;
  const report = metaData.reports.data.find(r => r.id === reportId) || {};

  return {
    lang: global.language,
    name: report.name
  };
};
ReportInfo.defaultProps = defaultProps;
ReportInfo.propTypes = propTypes;
export default connect(mapStateToProps)(ReportInfo);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/ReportInfo.jsx